<!-- <div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  {{ message }}
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="decline()">
    {{ btnCancelText }}
  </button>
  <button type="button" class="btn btn-primary" (click)="accept()">
    {{ btnOkText }}
  </button>
</div> -->

<div class="modal-height">
  <div class="modal-body">
    <div class="">
      <div class="text pt-3 pb-3">{{message}}</div>
      <div class="popup-line"></div>
    </div>
  </div>
  <div class="submit col-12 d-flex justify-content-end">
    <div class="pr-3" *ngIf="btnCancel">
      <button type="button " class="cancel-button pt-3" (click)="decline()">
        <span class="cancel">Cancel</span>
      </button>
    </div>
    <button type="button " class="add-button">
      <span class="add" (click)="accept()">{{btnOkText}}</span>
    </button>
  </div>
</div>
